import { createContext } from 'react';

import type { IWithdrawUsdRequestContext } from '../DialogWithdrawUsdRequest.helpers';

export const WithdrawUsdRequestContext = createContext<IWithdrawUsdRequestContext | null>(null);
